import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorIntlFr } from './fr-paginator-intl';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSlideToggleModule} from '@angular/material/slide-toggle'
import {MatChipsModule, MAT_CHIPS_DEFAULT_OPTIONS} from '@angular/material/chips'
import {MatTooltipModule} from '@angular/material/tooltip';
import { FooterComponent } from './components/footer/footer.component';
import { TableComponent } from './components/table/table.component';
import { GridFilterComponent } from './components/grid-filter/grid-filter.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { OrderSummaryComponent } from './components/order-summary/order-summary.component';
import { PurchaseOrderComponent } from './components/purchase-order/purchase-order.component';
import { ReceiptConfirmationComponent } from './components/order-summary/receipt-confirmation/receipt-confirmation.component';
import { ReportsComponent } from './components/reports/reports.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { ElectronicSignatureAttestationComponent } from './components/electronic-signature-attestation/electronic-signature-attestation.component';
import { OrderConfirmationComponent } from './components/order-summary/order-confirmation/order-confirmation.component';
import { UserMaintainenceComponent } from './components/adminstration/user-maintainence/user-maintainence.component';
import { StoreMaintainenceComponent } from './components/adminstration/store-maintainence/store-maintainence.component';
import { DcMaintainenceComponent } from './components/adminstration/dc-maintainence/dc-maintainence.component';
import { AdminstrationComponent } from './components/adminstration/adminstration.component';
import { MatSortModule } from '@angular/material/sort';
import { OrderdetailsComponent } from './components/order-summary/orderdetails/orderdetails.component';
import { LoaderComponent } from './components/loader/loader.component';
import {DcnEsignInterceptor} from './interceptor/dcn-esign-interceptor';
import { ReceiptConfirmationDiscrepancyComponent } from './components/order-summary/receipt-confirmation-discrepancy/receipt-confirmation-discrepancy.component';
import { ReceiptConfirmationDetailsComponent } from './components/order-summary/receipt-confirmation-details/receipt-confirmation-details.component';
import { OrderConfirmationDetailsComponent } from './components/order-summary/order-confirmation-details/order-confirmation-details.component';

import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DcUsersComponent } from './components/adminstration/dc-users/dc-users.component';
import { StoreUsersComponent } from './components/adminstration/store-users/store-users.component';

import { MatAutocompleteModule  } from "@angular/material/autocomplete";


import { EditStoreComponent } from './components/adminstration/edit-store/edit-store.component';
import { EditDcComponent } from './components/adminstration/edit-dc/edit-dc.component';
import { AddEditStoreUserComponent } from './components/adminstration/add-edit-store-user/add-edit-store-user.component';
import { AddEditDcUserComponent } from './components/adminstration/add-edit-dc-user/add-edit-dc-user.component';
import { DcDashboardComponent } from './components/dc-dashboard/dc-dashboard.component';


import { provideNgxWebstorage, withLocalStorage, withSessionStorage } from 'ngx-webstorage';
import { UsersListComponent } from './components/adminstration/users-list/users-list.component';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ApproveDialogComponent } from './components/approve-dialog/approve-dialog.component';
import { ApprovedDialogComponent } from './components/approved-dialog/approved-dialog.component';
import { StoreManagementComponent } from './components/store-management/store-management.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { DcnErrorComponent } from './components/dcn-error/dcn-error.component';
import { OrderMaintainenceComponent } from './components/order-maintainence/order-maintainence.component';
import { RouterModule } from '@angular/router';
import { CallBackComponent } from './components/call-back/call-back.component';


import { FileSaveAsComponent } from './components/file-save-as/file-save-as.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';

import { SignedOcReportComponent } from './components/reports/signed-oc-report/signed-oc-report.component';
import { SignedRcReportComponent } from './components/reports/signed-rc-report/signed-rc-report.component';
import { UnSignedPackagesComponent } from './components/reports/un-signed-packages/un-signed-packages.component';
import { MarReportComponent } from './components/reports/mar-report/mar-report.component';
import { MissingSignatureReportComponent } from './components/reports/missing-signature-report/missing-signature-report.component';
import { ExceptionReportComponent } from './components/reports/exception-report/exception-report.component';
import { ElectronicSignatureAttestationReportComponent } from './components/reports/electronic-signature-attestation-report/electronic-signature-attestation-report.component';
import { SpecialCharactersRestrictDirective} from './components/shared/special-characters-restirct.directive'
import { SpecialCharactersRestrictDirectiveAllowEmpty} from './components/shared/special-characters-restirct-allow-empty.directive'
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonPdfComponent } from './components/common-pdf/common-pdf.component';
import { getSaver, SAVER } from './components/model/saver';
import { YesNoDynamicTitleMessageDialogComponent } from './components/yes-no-dynamic-title-message-dialog/yes-no-dynamic-title-message-dialog.component';
import { UserIdleModule } from 'angular-user-idle';
import { DecimalNumberOnlyDirective } from './components/shared/decimal-number-only.directive';
import { LogoutComponent } from './components/logout/logout.component';
import { RightClickBlockDirective } from './components/shared/right-click-block.directive';
import { IdlePopupComponent } from './components/idle-popup/idle-popup.component';
import { ProtectedComponent } from './components/protected/protected.component';
import { environment } from 'src/environments/environment';
import { AdvanceSearchComponent } from './components/advance-search/advance-search.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import { BlockUIModule } from 'ng-block-ui';
import { EmailRestrictDirective} from './components/shared/email-restirct.directive'
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { BrowserUtils, InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { MsalRedirectComponent } from './components/msal-redirect/msal-redirect.component';
import { UserLicenseDirective } from './components/shared/user-license.directive';
import { CitiesDirective } from './components/shared/cities.directive';
import { StreetAddressDirective } from './components/shared/street-address.directive';
import { PostalCodeDirective } from './components/shared/postal-code.directive';
import { ProvinceCodeDirective } from './components/shared/province-code.directive';
import { StoreNameDirective } from './components/shared/store-name.directive';
import { AplhaNumericDirective } from './components/shared/aplha-numeric.directive';
import { CharsOnlyDirective } from './components/shared/chars-only.directive';







const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;



registerLocaleData(localeFr, 'fr', localeFrExtra);
function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(
   environment.msalSettings
  );
}

/**
 * MSAL v5: in popup/iframe, broadcast auth response to opener (COOP-safe).
 * Otherwise initialize and process any full-page redirect response.
 */
export function initializeMsalFactory(msalService: MsalService): () => Promise<void> {
  return async () => {
    if (BrowserUtils.isInPopup() || BrowserUtils.isInIframe()) {
      const { broadcastResponseToMainFrame } = await import('@azure/msal-browser/redirect-bridge');
      await broadcastResponseToMainFrame().catch(() => undefined);
      return;
    }
    await firstValueFrom(msalService.handleRedirectObservable()).catch(() => undefined);
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']); // Prod environment. Uncomment to use.
  protectedResourceMap.set('https://graph.microsoft.com/beta/me', ['user.read']);

  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap
  };
}
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Popup,
    authRequest: {
      scopes: ['user.read'],
      loginHint:''
    }
  };
}

// function countdownConfigFactory(): CountdownGlobalConfig {
//   return { format: `mm:ss` };
// }

// function MSALInterceptorConfigFactory(): MsalInterceptorConfig {
//   const protectedResourceMap = new Map<string, Array<string>>();
//   protectedResourceMap.set('https://graph.microsoft.com/beta/me', ['user.read']);

//   return {
//     interactionType: InteractionType.Popup,
//     protectedResourceMap,
//   };
// }
const MY_FORMATS = {
  parse: {
    
      dateInput: 'YYYY-MM-DD'
  },
  display: {
      dateInput: 'YYYY-MM-DD',
      monthYearLabel: 'YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'YYYY'
  }
}

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        HomeComponent,
        FooterComponent,
        TableComponent,
        GridFilterComponent,
        PaginationComponent,
        DashboardComponent,
        OrderSummaryComponent,
        PurchaseOrderComponent,
        ReceiptConfirmationComponent,
        ReportsComponent,
        ChecklistComponent,
        ElectronicSignatureAttestationComponent,
        OrderConfirmationComponent,
        UserMaintainenceComponent,
        StoreMaintainenceComponent,
        DcMaintainenceComponent,
        AdminstrationComponent,
        OrderdetailsComponent,
        LoaderComponent,
        ReceiptConfirmationDiscrepancyComponent,
        ReceiptConfirmationDetailsComponent,
        OrderConfirmationDetailsComponent,
        DcUsersComponent,
        StoreUsersComponent,
        EditStoreComponent,
        EditDcComponent,
        AddEditStoreUserComponent,
        AddEditDcUserComponent,
        DcDashboardComponent,
        UsersListComponent,
        ApproveDialogComponent,
        MsalRedirectComponent,
        ApprovedDialogComponent,
        StoreManagementComponent,
        UnauthorizedComponent,
        DcnErrorComponent,
        OrderMaintainenceComponent,
        CallBackComponent,
        FileSaveAsComponent,
        PdfViewerComponent,
        SignedOcReportComponent,
        SignedRcReportComponent,
        UnSignedPackagesComponent,
        MarReportComponent,
        MissingSignatureReportComponent,
        ExceptionReportComponent,
        ElectronicSignatureAttestationReportComponent,
        CommonPdfComponent,
        YesNoDynamicTitleMessageDialogComponent,
        DecimalNumberOnlyDirective,
        LogoutComponent,
        RightClickBlockDirective,
        IdlePopupComponent,
        ProtectedComponent,
        AdvanceSearchComponent,
        SpecialCharactersRestrictDirective,
        SpecialCharactersRestrictDirectiveAllowEmpty,
        EmailRestrictDirective,
        UserLicenseDirective,
        CitiesDirective,
        StreetAddressDirective,
        PostalCodeDirective,
        ProvinceCodeDirective,
        StoreNameDirective,
        AplhaNumericDirective,
        CharsOnlyDirective
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        MatAutocompleteModule,
        FormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatTabsModule,
        MatTableModule,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatRadioModule,
        ReactiveFormsModule,
        MatSortModule,
        MatProgressBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatChipsModule,
        MatDialogModule,
        PdfJsViewerModule,
        NgxExtendedPdfViewerModule,
        UserIdleModule.forRoot({ idle: 300, timeout: 10, ping: 2 }),
        TranslateModule.forRoot(),
        BlockUIModule.forRoot(),
        MsalModule], providers: [
        ...provideTranslateHttpLoader({
            prefix: './assets/i18n/',
            suffix: '.json'
        }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeMsalFactory,
            deps: [MsalService],
            multi: true
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        { provide: SAVER, useFactory: getSaver },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        { provide: HTTP_INTERCEPTORS, useClass: DcnEsignInterceptor, multi: true },
        { provide: MatPaginatorIntl, useClass: MatPaginatorIntlFr },
        {
            provide: MAT_CHIPS_DEFAULT_OPTIONS,
            useValue: {
                separatorKeyCodes: [ENTER, COMMA]
            }
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideNgxWebstorage(withLocalStorage(), withSessionStorage()),
    ] })
export class AppModule {
  
}
